<template>
  <div>

    <Title>移交固定资产清单</Title>
    <a-table
          bordered
          :dataSource="list"
          :pagination="false"
        >
          <a-table-column title="资产编码" data-index="assetCode"> </a-table-column>
          <a-table-column title="资产类别">
            <template slot-scope="text">
              <div style="display: flex;align-items: center">
                <DataDictFinder
                dictType="fixed_asset_type"
                :dictValue="text.category.categoryCode"
              />-
              {{text.category.subCategoryName}}
              </div>
            </template>
          </a-table-column>
          <a-table-column title="品牌型号" data-index="brandModel"> </a-table-column>
          <a-table-column title="采购日期" data-index="procurementTime"> </a-table-column>
          <a-table-column title="采购价格(元)" data-index="purchasePrice"> </a-table-column>
          <a-table-column title="资产负责人" data-index="responsiblePersonName"> </a-table-column>
          <a-table-column title="资产位置(部门)" data-index="deptName"> </a-table-column>
          <a-table-column title="财务编码" data-index="financialCode"> </a-table-column>
          <a-table-column title="启用日期" data-index="startTime"> </a-table-column>
          <a-table-column title="资产状态">
            <template slot-scope="text">
              <DataDictFinder
                dictType="fixed_asset_status"
                :dictValue="text.status"
                iconType="badge"
              />
            </template>
          </a-table-column>
        </a-table>
  </div>
</template>

<script>
import Title from "../Title";
import { mapState } from "vuex";
import request from "@/api/request";
function genCode(data) {
    return request({
    url: "/office-service/fixed-asset/gen-code",
    data,
    method: 'post'
  });
}
export default {
  components: {
    Title,
  },

  computed: {
    ...mapState("approval", ["detail"]),

    list() {
      return this.detail.extra?.fixedAssetList ?? [];
    },
  },
  mounted(){
    if(this.detail.taskDefinitionKey == 'arrival_confirmer'){
      this.list.forEach((row,index) => {
        genCode({
          categoryId: row.categoryId,
          startTime: row.startTime ? moment(row.startTime).format('YYYY-MM-DD') : '',
        }).then((res) => {
          console.log(this.detail.applicantId)
          this.list[index].assetCode = res;
          this.list[index].responsiblePersonName = this.detail.extra.applicant;
          this.list[index].responsiblePersonId = this.detail.extra.applicantId;
          this.list[index].deptId = this.detail.extra.applicantDeptId;
          this.list[index].deptName = this.detail.extra.applicantDeptName;
          this.list[index].status = 'fixed_asset_status_in_stock'
        });
      })
    }
  }
};
</script>